import React from 'react';
import map from 'lodash.map';
import isEmpty from 'lodash.isempty';
import filesize from 'filesize';

export const LegalDocumentCard = ({ ...props }) => (
	<div className="container">
		<h2 className="page__title">{props.displayText}</h2>
		<div className="page__content" dangerouslySetInnerHTML={{ __html: props.content }} />
	</div>
);
